import React, { Component } from 'react';

//import './App.css';


export class CardButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      archetype: this.props.cardTitle,
			archetypeName: this.props.archetypeName,
      chosen: "no",
      titleBackground: "notSelectedText CardText",
      cardRarity: this.props.rarity + " notSelected"
    };

  }



  toggleChosen() {
    var isChosen = this.state.chosen === "yes" ? "no" : "yes";
    this.setState({ chosen: isChosen });

    if (isChosen === "yes") {
      this.setState({
        titleBackground: this.props.titleBackground + " CardText",
        cardRarity: this.props.rarity +  " Selected"
      });
    } else {
      this.setState({
        titleBackground: "notSelectedText CardText",
        cardRarity: this.props.rarity + " notSelected"
      });
    }

  }

  render() {

    return (
	    <label htmlFor={ this.state.archetypeName } className={ "CardButton archetypeCheckbox " + this.state.cardRarity + ' ' + this.props.cardBackground } onChange={ this.toggleChosen.bind(this) } >
        <div className={ this.props.rarity === "legendary2" ? "legendary2Top" : "notLegendary" }></div>
        <div className={ this.props.rarity === "legendary2" ? "legendary2Bottom" : "notLegendary" }></div>

        <div className="CardText">
          <div className="CardText-inner">
            <p className={ this.state.titleBackground }>
              { this.state.archetype }
            </p>
          </div>
        </div>

				<input 	type="checkbox"
								name="archetype"
								value={ this.state.archetypeName }
								id={ this.state.archetypeName } />


			</label>

    )
  }
}

export default CardButton;



// WEBPACK FOOTER //
// ./src/Components/CardButton.js